export const environment = {
  production: true,
  baseWeb: 'https://bcp.set.or.th',
  baseUrl: 'https://bcp.set.or.th/api',
  acknowledgeImage: 'https://enterprise.set.or.th/EnterpriseApp/EmpPhoto',
  hrEndpoint: 'https://hr.set.or.th',
  hrPortalEndpoint: 'https://portal.setint.or.th/hr-portal',
  activateBCPNotificationChannel: 'NEWS',
  local: false
};
